/**
 * Canary Mode Configuration
 *
 * Enable via REACT_APP_CANARY_MODE=true in .env
 * Used to visually distinguish test/preview builds from production
 *
 * This file re-exports from theme.js for backwards compatibility.
 * For new code, prefer importing directly from theme.js
 */

export {
  isCanaryMode,
  canaryTheme,
  productionTheme,
  getCurrentTheme,
} from './theme';
